import { Box, Typography } from "@mui/material";

import useFirebaseContext from "@/hooks/useFirebaseAuth";
import { UserRole } from "@/types";

interface Props {
  answer: string;
  setAnswer: (val: string) => void;
  showSolution: boolean;
  points?: number;
  score?: number;
}

const ShortAnswerInput = ({
  answer,
  points,
  score,
  setAnswer,
  showSolution,
}: Props) => {
  const { userRole } = useFirebaseContext();
  const getScoreText = () => {
    if (!score || !points) return "";
    const percentage = (score / points) * 100;
    if (percentage >= 60) return "Correct";
    if (percentage >= 40) return "Almost";
    return "Incorrect";
  };

  const getScoreColor = () => {
    if (!score || !points) return "";
    const percentage = (score / points) * 100;
    if (percentage >= 60) return "success";
    if (percentage >= 40) return "warning";
    return "error";
  };

  return (
    <Box>
      <Box
        component="textarea"
        disabled={showSolution}
        rows={4}
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        placeholder="Enter your answer here..."
        style={{
          width: "100%",
          padding: 12,
          borderRadius: 8,
          border: "1px solid #e0e0e0",
          fontSize: 16,
          marginBottom: 8,
          resize: "vertical",
        }}
      />
      {showSolution && userRole === UserRole.Student && (
        <Typography variant="body1" textAlign="right" color={getScoreColor()}>
          {getScoreText()} {score} / {points}
        </Typography>
      )}
    </Box>
  );
};

export default ShortAnswerInput;
